import executeQuery from "#lib/db"

export const getShoppingList = async ({ userID }: { userID: string }) => {
	const list = await executeQuery({
		query: `select * from shopping_list where userID=${userID}`,
	})

	return list
}
